import { render, staticRenderFns } from "./SubscriptionStartButton.vue?vue&type=template&id=23c15cdc&scoped=true&"
import script from "./SubscriptionStartButton.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionStartButton.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionStartButton.vue?vue&type=style&index=0&id=23c15cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c15cdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('23c15cdc', component.options)
    } else {
      api.reload('23c15cdc', component.options)
    }
    module.hot.accept("./SubscriptionStartButton.vue?vue&type=template&id=23c15cdc&scoped=true&", function () {
      api.rerender('23c15cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/SubscriptionStartButton.vue"
export default component.exports